/**
 * Adaptateur - BiometricFingerprintAdapter
 *
 * Mock du scanner d'empreinte digitale
 * Note: Utilisez un adaptateur réel pour la production
 */

import { IBiometricService } from '../../application/ports/output/IBiometricService';
import { BiometricAuthResult } from '../../domain/aggregates/WithdrawalWorkflow';

export class BiometricFingerprintAdapter implements IBiometricService {
  private scanning = false;
  private cancelRequested = false;

  /**
   * Démarre un scan d'empreinte
   */
  async startFingerprintScan(): Promise<void> {
    this.scanning = true;
    this.cancelRequested = false;
    console.warn('[BiometricFingerprintAdapter] Mock adapter - use real biometric adapter for production');
  }

  /**
   * Attend le résultat du scan
   */
  async waitForScan(_timeoutMs = 30000): Promise<BiometricAuthResult> {
    return new Promise((resolve) => {
      setTimeout(() => {
        if (this.cancelRequested) {
          this.scanning = false;
          resolve({
            success: false,
            errorCode: 'SCAN_CANCELLED',
            timestamp: new Date(),
          });
          return;
        }

        this.scanning = false;
        resolve({
          success: false,
          errorCode: 'MOCK_ADAPTER_NOT_SUPPORTED',
          timestamp: new Date(),
        });
      }, 1000);
    });
  }

  /**
   * Annule un scan en cours
   */
  cancelScan(): void {
    this.cancelRequested = true;
    console.warn('[BiometricFingerprintAdapter] Mock adapter - use real biometric adapter for production');
  }

  /**
   * Vérifie si le scanner est disponible
   */
  async isAvailable(): Promise<boolean> {
    console.warn('[BiometricFingerprintAdapter] Mock adapter - use real biometric adapter for production');
    return false;
  }

  /**
   * Vérifie si un scan est en cours
   */
  isScanning(): boolean {
    return this.scanning;
  }
}
